import React from 'react';

import styles from './Layout.css';

const Layout: React.FC<JSX.IntrinsicElements['main']> = ({ children, ...props }) => {
    return (
        <main className={styles.layout} {...props}>
            {children}
        </main>
    );
};

export default Layout;
